import SummaryPage from './summary-page-view'

export default SummaryPage
